import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "top_game_1"
};
const _hoisted_2 = {
  class: "title_index"
};
const _hoisted_3 = {
  class: "default_title",
  isneedmore: "true"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = ["href"];
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "More", -1);
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  t: "1693725090959",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "28303",
  width: "1.3rem",
  height: "1.3rem",
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M512.5 289.1l222.9 222.8-222.9 223-36.2-36.2L663 511.9 476.3 325.3z",
  "p-id": "28304",
  fill: "#ffffff"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M324.8 289.1l222.9 222.8-222.9 223-36.2-36.2 186.7-186.8-186.7-186.6z",
  "p-id": "28305",
  fill: "#ffffff"
})], -1);
const _hoisted_8 = [_hoisted_6, _hoisted_7];
const _hoisted_9 = {
  class: "top_game"
};
const _hoisted_10 = ["href", "test"];
const _hoisted_11 = {
  class: "game_icon"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_image = _resolveComponent("van-image");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, [_createVNode(_component_van_image, {
    src: `${$setup.svgPreUrl}/${$setup.title}.svg`,
    style: {
      "width": "1rem"
    },
    alt: ""
  }, {
    loading: _withCtx(() => [_createVNode(_component_van_loading, {
      type: "spinner",
      size: "20"
    })]),
    _: 1
  }, 8, ["src"])]), _createTextVNode(" " + _toDisplayString($setup.title) + " ", 1), _createElementVNode("a", {
    href: `./more.html?type=${$setup.title}`,
    style: {
      "display": "flex",
      "width": "unset",
      "float": "right",
      "text-decoration": "none"
    }
  }, _hoisted_8, 8, _hoisted_5)])])]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list.slice(0, 8), (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "game_item",
      key: index
    }, [_createElementVNode("a", {
      href: `./detail.html?id=${item.id}`,
      test: JSON.stringify(item)
    }, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_van_image, {
      style: {
        "border-radius": "1rem",
        "overflow": "hidden"
      },
      "data-src": item.appLogo,
      src: item.appLogo,
      alt: ""
    }, {
      loading: _withCtx(() => [_createVNode(_component_van_loading, {
        size: "20"
      })]),
      _: 2
    }, 1032, ["data-src", "src"])]), _createElementVNode("span", null, _toDisplayString(item.name), 1)], 8, _hoisted_10)]);
  }), 128))])]);
}